import { makeStyles } from '@material-ui/core/styles';
import { DSTheme } from '../../styles/themes/types';

export default makeStyles((theme: DSTheme) => ({
  section: {
    padding: '32px',

    '& .MuiGrid-container': {
      marginBottom: '32px',
    },

    '& ul': {
      color: theme.palette.text.primary,
    },
    '& .link-row': {
      display: 'flex',
      flexDirection: 'row',

      '& p': {
        color: theme.palette.text.primary,
      },
    },
    '& .about-details': {
      maxWidth: '324px',
    },
  },
  text: {
    color: theme.palette.type === 'dark' ? theme.palette.text.primary : theme.palette.primary.main,
  },
  landingCardRow: {
    display: 'grid',
    gridTemplateColumns: '348px',
    gridTemplateRows: '424px',
    columnGap: '24px',
    placeItems: 'center',
    marginLeft: '12px',
    width: '100%',

    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: '348px 348px',
    },

    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: '400px 400px',
      gridTemplateRows: '400px',
    },
  },
  section1: {
    backgroundColor: theme.palette.background.default,
  },
  section2: {
    backgroundColor: theme.palette.background.navigation,
  },
  landingScroll: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: '50px',
    width: '100px',

    '& svg': {
      cursor: 'pointer',
      width: '15px',
      height: '15px',
    },
    '& .inactive': {
      width: '6px',
      height: '6px',

      marginTop: '2px',
    },
  },
}));
